import types from "./types";
import { ADD_ITEM_TO_BASKET } from "../basket/types";
import utils, { sync_queue_with_basket } from "./utils";

export const init_state = {};

export default function globalReducer(state = init_state, action) {
  switch (action.type) {
    case types.APP_DATA:
      return {
        ...state,
        user: {
          ...state.user,
          app_data_loading: true,
          app_data_failed: false,
        },
      };
    case types.APP_DATA_FAILED:
      return {
        ...state,
        user: {
          ...state.user,
          app_data_loading: false,
          app_data_failed: true,
        },
      };
    case types.APP_DATA_FINISHED:
      const updatedAt =
        action.payload && action.payload.isUpdated
          ? new Date().toISOString()
          : state.user.app_data_updatedAt;
      return {
        ...state,
        user: {
          ...state.user,
          app_data_loading: false,
          app_data_failed: false,
          app_data_updatedAt: updatedAt,
        },
      };
    case types.LOGOUT:
      return utils.reducer_logout(state);

    // Basket
    case ADD_ITEM_TO_BASKET:
      return sync_queue_with_basket(state, action.payload);
    default:
      return state;
  }
}
